(function () {
  var FIRST_REWARD_CENTS = 10000;
  var SECOND_REWARD_CENTS = 30000;
  var FIRST_REWARD_NAME = "Fuse Beads DIY Tool Kit";
  var SECOND_REWARD_NAME = "GUDI Makeup Brush Set";
  var FIRST_REWARD_URL = "https://koollia.com/products/2-6mm-mard-120-colors-fuse-beads-full-diy-tool-kit";
  var SECOND_REWARD_URL = "https://koollia.com/products/gudi-peach-nude-pink-13pcs-full-makeup-brush-set-with-holder";
  var FIRST_REWARD_IMAGE = "https://koollia.com/cdn/shop/files/82517623b3e7c1494226cbe37a1196ed_a11abb2a-137a-4834-a512-a7f211bf67ba.jpg?v=1780375324&width=240";
  var SECOND_REWARD_IMAGE = "https://koollia.com/cdn/shop/files/1_7d2f2272-4dbf-4935-b1f6-1680e6c0761e.jpg?v=1780375811&width=240";

  function hasReducedMotion() {
    return window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  }

  function canAnimate() {
    return !hasReducedMotion() && (window.gsap || (window.Element && Element.prototype.animate));
  }

  function getTargets(targets) {
    if (!targets) return [];
    if (targets instanceof Element) return [targets];
    return Array.prototype.slice.call(targets);
  }

  function easeToCss(ease) {
    if (!ease) return "ease-out";
    if (ease.indexOf("power2") === 0) return "cubic-bezier(0.22, 1, 0.36, 1)";
    if (ease.indexOf("power3") === 0) return "cubic-bezier(0.16, 1, 0.3, 1)";
    return "ease-out";
  }

  function frameFromVars(vars) {
    var frame = {};
    var transforms = [];

    if (typeof vars.y !== "undefined") transforms.push("translateY(" + vars.y + "px)");
    if (typeof vars.scale !== "undefined") transforms.push("scale(" + vars.scale + ")");
    if (transforms.length) frame.transform = transforms.join(" ");
    if (typeof vars.autoAlpha !== "undefined") frame.opacity = vars.autoAlpha;
    if (typeof vars.opacity !== "undefined") frame.opacity = vars.opacity;
    if (typeof vars.width !== "undefined") frame.width = vars.width;

    return frame;
  }

  function animateTo(targets, vars) {
    if (!canAnimate()) return;
    if (window.gsap) {
      window.gsap.to(targets, vars);
      return;
    }

    getTargets(targets).forEach(function (target) {
      var toFrame = frameFromVars(vars);
      target.animate([toFrame], {
        duration: Math.round((vars.duration || 0.4) * 1000),
        easing: easeToCss(vars.ease),
        fill: "forwards"
      });
    });
  }

  function animateFromTo(targets, fromVars, toVars) {
    if (!canAnimate()) return;
    if (window.gsap) {
      window.gsap.fromTo(targets, fromVars, toVars);
      return;
    }

    var nodes = getTargets(targets);
    var eachDelay = toVars.stagger ? Math.round(toVars.stagger * 1000) : 0;
    nodes.forEach(function (target, index) {
      var animation = target.animate([frameFromVars(fromVars), frameFromVars(toVars)], {
        duration: Math.round((toVars.duration || 0.5) * 1000),
        delay: eachDelay * index,
        easing: easeToCss(toVars.ease),
        fill: "both"
      });

      animation.addEventListener("finish", function () {
        target.style.opacity = "";
        target.style.transform = "";
        target.style.visibility = "";
      });
    });
  }

  function formatMoney(cents) {
    return "$" + (Math.max(0, cents) / 100).toFixed(2);
  }

  function escapeHtml(value) {
    return String(value)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#039;");
  }

  function giftStatusMarkup(total) {
    var giftName = FIRST_REWARD_NAME;
    var giftUrl = FIRST_REWARD_URL;
    var giftImage = FIRST_REWARD_IMAGE;
    var tag = "$100 gift";
    var note = formatMoney(FIRST_REWARD_CENTS - total) + " away";

    if (total >= SECOND_REWARD_CENTS) {
      giftName = SECOND_REWARD_NAME;
      giftUrl = SECOND_REWARD_URL;
      giftImage = SECOND_REWARD_IMAGE;
      tag = "$300 unlocked";
      note = "Refresh cart, then manually add this gift from the cart milestone before checkout.";
    } else if (total >= FIRST_REWARD_CENTS) {
      tag = "$100 unlocked";
      note = "Refresh cart, then manually add this gift from the cart milestone before checkout.";
    }

    return '<a class="kll-june-cart-rail__gift" href="' + giftUrl + '">' +
      '<span class="kll-june-cart-rail__gift-media"><img src="' + giftImage + '" alt="' + escapeHtml(giftName) + '" width="240" height="240" loading="lazy"></span>' +
      '<span class="kll-june-cart-rail__gift-copy"><span>' + tag + '</span><strong>' + escapeHtml(giftName) + '</strong><em>' + escapeHtml(note) + '</em></span>' +
    '</a>';
  }

  function updateRewardCart(page, state) {
    var totalNode = page.querySelector("[data-kll-cart-total]");
    var statusNode = page.querySelector("[data-kll-cart-status]");
    var progressNode = page.querySelector("[data-kll-cart-progress]");
    var progressTrack = page.querySelector(".kll-june-cart-rail__track");
    var itemsNode = page.querySelector("[data-kll-cart-items]");
    var total = state.baseCents + state.items.reduce(function (sum, item) {
      return sum + item.priceCents;
    }, 0);
    var progress = Math.min(100, Math.round((total / SECOND_REWARD_CENTS) * 100));

    if (totalNode) totalNode.textContent = formatMoney(total);
    if (progressNode) {
      if (canAnimate()) {
        animateTo(progressNode, {
          width: progress + "%",
          duration: 0.45,
          ease: "power2.out",
          overwrite: "auto"
        });
      } else {
        progressNode.style.width = progress + "%";
      }
    }
    if (progressTrack) progressTrack.setAttribute("aria-valuenow", String(Math.round(total / 100)));

    if (statusNode) {
      if (total < FIRST_REWARD_CENTS) {
        statusNode.textContent = formatMoney(FIRST_REWARD_CENTS - total) + " to unlock Fuse Beads Kit.";
      } else if (total < SECOND_REWARD_CENTS) {
        statusNode.textContent = "Fuse Beads Kit unlocked. Refresh cart, then manually add it from the cart milestone.";
      } else {
        statusNode.textContent = "Makeup Brush Set unlocked. Refresh cart, then manually add it from the cart milestone.";
      }
    }

    if (!itemsNode) return;
    itemsNode.innerHTML = giftStatusMarkup(total);
  }

  function addVariantToShopifyCart(variantId) {
    if (!variantId || !window.fetch) {
      return Promise.resolve();
    }

    return window.fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      },
      body: JSON.stringify({
        id: Number(variantId),
        quantity: 1
      })
    }).then(function (response) {
      if (!response.ok) throw new Error("Cart add failed");
      return response.json();
    });
  }

  function setupRewardBarBehavior(page) {
    var shop = page.querySelector(".kll-june-shop");
    var shopMain = page.querySelector(".kll-june-shop__main");
    var rail = page.querySelector("[data-kll-cart-rail]");
    if (!shop || !rail) return;
    var wasFollowing = false;

    function getVisibleHeaderOffset() {
      var header = document.querySelector("sticky-header, .shopify-section-header, .header-wrapper, header");
      if (!header) return 12;

      var rect = header.getBoundingClientRect();
      var isVisibleAtTop = rect.bottom > 0 && rect.top < 20;

      if (!isVisibleAtTop) return 12;
      return Math.round(rect.bottom + 8);
    }

    function updateCompactState() {
      var rect = shop.getBoundingClientRect();
      var mainRect = shopMain ? shopMain.getBoundingClientRect() : rect;
      var topOffset = getVisibleHeaderOffset();
      var shouldFollow = mainRect.top <= topOffset + 24 && rect.bottom > topOffset + 160;

      page.style.setProperty("--kll-reward-top", topOffset + "px");
      page.classList.toggle("is-reward-fixed", shouldFollow);
      page.classList.toggle("is-reward-compact", shouldFollow);

      if (canAnimate() && shouldFollow && !wasFollowing) {
        animateFromTo(rail, {
          y: -10,
          autoAlpha: 0.96
        }, {
          y: 0,
          autoAlpha: 1,
          duration: 0.22,
          ease: "power2.out",
          overwrite: "auto",
          clearProps: "transform,opacity,visibility"
        });
      }

      wasFollowing = shouldFollow;

      if (!shouldFollow) {
        rail.classList.remove("is-expanded");
      }
    }

    rail.addEventListener("click", function (event) {
      if (!page.classList.contains("is-reward-compact")) return;
      if (event.target.closest("[data-kll-cart-add]")) return;
      rail.classList.toggle("is-expanded");

      if (canAnimate() && rail.classList.contains("is-expanded")) {
        animateFromTo(rail, {
          y: -4
        }, {
          y: 0,
          duration: 0.18,
          ease: "power2.out",
          overwrite: "auto",
          clearProps: "transform"
        });
      }
    });

    document.addEventListener("click", function (event) {
      if (!rail.classList.contains("is-expanded")) return;
      if (rail.contains(event.target)) return;
      rail.classList.remove("is-expanded");
    });

    window.addEventListener("scroll", updateCompactState, { passive: true });
    window.addEventListener("resize", updateCompactState);
    updateCompactState();
  }

  function revealGroup(nodes, options) {
    if (!canAnimate() || !nodes.length) return;

    animateFromTo(nodes, {
      y: options && options.y ? options.y : 18,
      autoAlpha: 0
    }, {
      y: 0,
      autoAlpha: 1,
      duration: options && options.duration ? options.duration : 0.62,
      ease: "power2.out",
      stagger: options && options.stagger ? options.stagger : 0.08,
      overwrite: "auto",
      clearProps: "transform,opacity,visibility"
    });
  }

  function setupEntranceAnimations(page) {
    if (!canAnimate()) return;

    var hero = page.querySelector(".kll-june-hero");
    if (hero) {
      var heroPhoto = hero.querySelector(".kll-june-hero__photo");
      var heroScroll = hero.querySelector(".kll-june-scroll");

      if (window.gsap) {
        var heroTimeline = window.gsap.timeline({
          defaults: {
            duration: 0.72,
            ease: "power2.out"
          }
        });

        heroTimeline.from(hero.querySelectorAll(".kll-june-kicker, h1, .kll-june-hero__copy p:not(.kll-june-kicker)"), {
          y: 16,
          autoAlpha: 0,
          stagger: 0.08
        });

        if (heroPhoto) {
          heroTimeline.from(heroPhoto, {
            scale: 0.985,
            autoAlpha: 0,
            duration: 0.9
          }, "<0.12");
        }

        if (heroScroll) {
          heroTimeline.from(heroScroll, {
            y: 10,
            autoAlpha: 0,
            duration: 0.45
          }, "<0.35");
        }
      } else {
        revealGroup(hero.querySelectorAll(".kll-june-kicker, h1, .kll-june-hero__copy p:not(.kll-june-kicker)"), {
          y: 16,
          stagger: 0.08,
          duration: 0.58
        });

        if (heroPhoto) {
          animateFromTo(heroPhoto, {
            scale: 0.985,
            autoAlpha: 0
          }, {
            scale: 1,
            autoAlpha: 1,
            duration: 0.7,
            ease: "power2.out"
          });
        }

        if (heroScroll) {
          animateFromTo(heroScroll, {
            y: 10,
            autoAlpha: 0
          }, {
            y: 0,
            autoAlpha: 1,
            duration: 0.42,
            ease: "power2.out"
          });
        }
      }
    }

    if (!("IntersectionObserver" in window)) return;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;

        var section = entry.target;
        observer.unobserve(section);

        if (section.classList.contains("kll-june-campaign")) {
          revealGroup(section.querySelectorAll(".kll-june-campaign__intro > *, .kll-june-reward, .kll-june-campaign__actions > *"), {
            stagger: 0.06,
            y: 14
          });
        } else if (section.classList.contains("kll-june-shop")) {
          revealGroup(section.querySelectorAll(".kll-june-shop__head > *, .kll-june-tabs, .kll-june-cart-rail, [data-kll-product-card]:not([hidden])"), {
            stagger: 0.045,
            y: 12
          });
        } else if (section.classList.contains("kll-june-faq")) {
          revealGroup(section.querySelectorAll(".kll-june-faq__head > *, .kll-june-faq__item"), {
            stagger: 0.06,
            y: 12
          });
        }
      });
    }, {
      threshold: 0.16
    });

    page.querySelectorAll(".kll-june-campaign, .kll-june-shop, .kll-june-faq").forEach(function (section) {
      observer.observe(section);
    });
  }

  function setupFaq(page) {
    page.querySelectorAll(".kll-june-faq__question").forEach(function (button) {
      button.addEventListener("click", function () {
        var item = button.closest(".kll-june-faq__item");
        var isOpen = item && item.classList.contains("is-open");

        page.querySelectorAll(".kll-june-faq__item").forEach(function (faqItem) {
          var faqButton = faqItem.querySelector(".kll-june-faq__question");
          faqItem.classList.remove("is-open");
          if (faqButton) faqButton.setAttribute("aria-expanded", "false");
        });

        if (item && !isOpen) {
          item.classList.add("is-open");
          button.setAttribute("aria-expanded", "true");
        }
      });
    });
  }

  var pages = document.querySelectorAll("[data-kll-june-page]");
  if (!pages.length) return;

  pages.forEach(function (page) {
    var state = {
      baseCents: Number(page.getAttribute("data-kll-cart-cents")) || 0,
      items: []
    };

    page.querySelectorAll("[data-kll-scroll-target]").forEach(function (button) {
      button.addEventListener("click", function (event) {
        var selector = button.getAttribute("data-kll-scroll-target");
        var target = selector ? page.querySelector(selector) || document.querySelector(selector) : null;

        if (!target) return;

        event.preventDefault();
        target.scrollIntoView({
          behavior: "smooth",
          block: "start"
        });
      });
    });

    page.querySelectorAll("[data-kll-filter]").forEach(function (tab) {
      tab.addEventListener("click", function () {
        var category = tab.getAttribute("data-kll-filter");
        page.querySelectorAll("[data-kll-filter]").forEach(function (otherTab) {
          var isActive = otherTab === tab;
          otherTab.classList.toggle("is-active", isActive);
          otherTab.setAttribute("aria-selected", String(isActive));
        });

        page.querySelectorAll("[data-kll-product-card]").forEach(function (card) {
          card.hidden = card.getAttribute("data-category") !== category;
        });

        revealGroup(page.querySelectorAll('[data-kll-product-card][data-category="' + category + '"]:not([hidden])'), {
          stagger: 0.035,
          y: 10,
          duration: 0.46
        });
      });
    });

    page.querySelectorAll("[data-kll-cart-add]").forEach(function (button) {
      button.addEventListener("click", function () {
        var title = button.getAttribute("data-title") || "Selected product";
        var priceCents = Number(button.getAttribute("data-price-cents")) || 0;
        var variantId = button.getAttribute("data-variant-id");
        var originalText = button.textContent;

        button.disabled = true;
        button.textContent = "Adding...";

        addVariantToShopifyCart(variantId).then(function () {
          state.items.push({
            title: title,
            priceCents: priceCents
          });

          button.classList.add("is-added");
          button.textContent = "Added";
          if (canAnimate()) {
            animateFromTo(button, {
              scale: 0.98
            }, {
              scale: 1,
              duration: 0.18,
              ease: "power2.out",
              overwrite: "auto",
              clearProps: "transform"
            });
          }
          updateRewardCart(page, state);
        }).catch(function () {
          button.textContent = "Try again";
        }).finally(function () {
          window.setTimeout(function () {
            button.disabled = false;
            button.classList.remove("is-added");
            button.textContent = originalText;
          }, 1200);
        });
      });
    });

    setupEntranceAnimations(page);
    setupRewardBarBehavior(page);
    setupFaq(page);
    updateRewardCart(page, state);
  });
})();
